module.exports = __webpack_public_path__ + "assets/795c64e7e96e13385eb4a08a9d0b2420.svg";